<template>
  <SimplePage title="他社予約取り込み設定" hideStoreName showBack :onHome="back">
    <template #main>
      <LoadingIndicator v-if="busy" />
      <div class="main">
        <div class="contents">
          <div class="section-group">
            <p class="note">
              他社予約取り込み用のメールアドレスを他社グルメサイトの通知先に登録してください。他社の予約サービスとぐるなび台帳を連携し、他社予約情報をぐるなび台帳に取り込むことができます。
            </p>
            <PropertySection
              class="copy"
              title="他社予約取り込み用メールアドレス"
              description="下記の予約取り込み用メールアドレスを、各社の設定画面で連絡先メールアドレスに設定してください。"
              :data="settings.forwardingAddress || ''"
              button="メールアドレスをコピー"
              @click="showCopyDialog"
            />
            <Button class="mailbox" flat icon @click="$router.push({ name: 'MailBox' })">
              <MailInverseIcon />受信メールを確認
            </Button>
          </div>
          <div class="section-group">
            <PropertySection
              title="他社予約取り込みの仮配席"
              :description="
                `他社予約の予約日時・人数で自動配席します。\nテーブル種別は判別されませんので必ず確認してください。`
              "
              data="仮配席"
              :status="settings.tableAllocation ? '利用中' : '停止中'"
              :red="!settings.tableAllocation"
              @click="changeStatus('tableAllocation')"
            />
          </div>
          <div class="section-group">
            <PropertySection
              title="他社予約取り込みの開始・停止"
              :description="
                `開始設定前に予約サイトのメール通知先に予約メール取り込み用メールアドレスを登録する必要があります。\n予約取り込み開始変更後に予約された予約情報より取り込まれます。`
              "
              data="食べログ予約取り込み"
              :status="statusText('tabelog')"
              :red="!settings.tabelog || hasResrakuSync"
              :disabled="hasResrakuSync"
              @click="changeStatus('tabelog')"
            />
            <PropertySection
              data="ホットペッパー予約取り込み"
              :status="statusText('hotpepper')"
              :red="!settings.hotpepper || hasResrakuSync"
              :disabled="hasResrakuSync"
              @click="changeStatus('hotpepper')"
            />
            <PropertySection
              data="一休予約取り込み"
              :status="settings.ikyu ? '取り込み中' : '停止中'"
              :red="!settings.ikyu"
              @click="changeStatus('ikyu')"
            />
            <PropertySection
              data="OZmall予約取り込み"
              :status="statusText('ozmall')"
              :red="!settings.ozmall || hasResrakuSync"
              :disabled="hasResrakuSync"
              @click="changeStatus('ozmall')"
            />
            <PropertySection
              data="PayPayグルメ予約取り込み"
              :status="settings.paypay ? '取り込み中' : '停止中'"
              :red="!settings.paypay"
              @click="changeStatus('paypay')"
            />
          </div>
        </div>
      </div>
    </template>
  </SimplePage>
</template>

<script>
import { mapState } from 'vuex'
import SimplePage from '@/components/templates/SimplePage'
import Button from '@/components/atoms/Button'
import MailInverseIcon from '@/components/icons/mailInverse'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import Dialog from '@/components/molecules/ModalDialog'
import PropertySection from '@/components/molecules/PropertySection'

export default {
  name: 'MailConversion',
  components: {
    SimplePage,
    Button,
    MailInverseIcon,
    LoadingIndicator,
    PropertySection,
  },
  props: {
    confirmed: Boolean,
  },
  computed: {
    ...mapState({
      settings: state => state.mailConversion.settings,
      busy: state => state.mailConversion.busy,
    }),
    mediaList() {
      const { tableAllocation, tabelog, hotpepper, ikyu, ozmall, paypay } = this.settings
      return {
        tableAllocation: { name: '他社予約取り込み', status: tableAllocation },
        tabelog: { name: '食べログ', status: tabelog },
        hotpepper: { name: 'ホットペッパー', status: hotpepper },
        ikyu: { name: '一休', status: ikyu },
        ozmall: { name: 'OZmall', status: ozmall },
        paypay: { name: 'PayPayグルメ', status: paypay },
      }
    },
    hasResrakuSync() {
      return this.settings.resrakuSync
    },
  },
  mounted() {
    if (!this.settings?.termAgreement && !this.confirmed) this.fetch()
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('mailConversion/get')
    },
    back() {
      location.assign('/store/init')
    },
    showCopyDialog() {
      navigator.clipboard.writeText(this.settings.forwardingAddress)
      Dialog.show({ title: 'コピーしました。' })
    },
    statusText(media) {
      if (this.hasResrakuSync) return 'レスラク連携中のためご利用いただけません'
      return this.settings[media] ? '取り込み中' : '停止中'
    },
    async changeStatus(media) {
      const isTableAllocation = media === 'tableAllocation'
      const label = this.mediaList[media].status ? '停止' : '開始'
      const text = `${this.mediaList[media].name}の${isTableAllocation ? '仮配席' : '予約取り込み'}を${label}`
      if (
        (await Dialog.confirm({
          title: text,
          message: `${text}します${isTableAllocation ? 'か？' : '。'}`,
          cancelText: '戻る',
          okText: label,
        })) &&
        (await this.$store.dispatch('mailConversion/update', media))
      ) {
        this.fetch()
      }
    },
  },
}
</script>
<style lang="postcss" scoped>
.main {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 24px;
}

.contents {
  display: grid;
  grid-gap: 44px;
}

.section-group {
  display: grid;
  grid-gap: 8px;

  >>> .description {
    font-size: 15px;
  }
}

.note {
  margin-bottom: 16px;
}

.copy {
  >>> .button {
    width: 192px;
  }
}

.mailbox {
  fill: var(--very-dark-gray-2);
  font-size: 15px;
}
</style>
